(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-assurance"] && !Shopify.designMode) return;
  try {
    (() => {
    const initializeAssuranceDialogs = (root) => {
      root.querySelectorAll('[data-assurance]').forEach((component) => {
        if (component.dataset.assuranceBound === 'true') return;
        component.dataset.assuranceBound = 'true';

        const dialog = component.querySelector('[data-assurance-dialog]');
        const title = component.querySelector('[data-assurance-dialog-title]');
        const description = component.querySelector('[data-assurance-dialog-description]');
        const image = component.querySelector('[data-assurance-dialog-image]');
        const link = component.querySelector('[data-assurance-dialog-link]');
        const close = component.querySelector('[data-assurance-close]');

        if (!dialog || !title || !description || !image || !link || !close) return;

        component.querySelectorAll('[data-assurance-trigger]').forEach((trigger) => {
          trigger.addEventListener('click', () => {
            title.textContent = trigger.dataset.title || '';
            description.textContent = trigger.dataset.description || '';
            description.hidden = !description.textContent;

            if (trigger.dataset.image) {
              image.src = trigger.dataset.image;
              image.alt = trigger.dataset.imageAlt || '';
              image.hidden = false;
            } else {
              image.removeAttribute('src');
              image.alt = '';
              image.hidden = true;
            }

            if (trigger.dataset.url) {
              link.href = trigger.dataset.url;
              link.hidden = false;
            } else {
              link.removeAttribute('href');
              link.hidden = true;
            }

            dialog.showModal();
          });
        });

        close.addEventListener('click', () => dialog.close());
        dialog.addEventListener('click', (event) => {
          if (event.target === dialog) dialog.close();
        });
      });
    };

    const start = () => initializeAssuranceDialogs(document);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAssuranceDialogs(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-mobile-purchase-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    const initMobilePurchaseBars = () => {
      const bars = document.querySelectorAll('[data-product-mobile-purchase]');

      bars.forEach((bar) => {
        if (bar.dataset.mobilePurchaseReady === 'true') return;

        const sectionId = bar.dataset.sectionId;
        const action = bar.querySelector('[data-mobile-purchase-action]');
        const price = bar.querySelector('[data-mobile-purchase-price]');
        const form = document.getElementById(`product-purchase-${sectionId}`);

        if (!action || !form) return;

        bar.dataset.mobilePurchaseReady = 'true';

        const addToCart = form.querySelector('.btn--add-to-cart');
        const productRoot = form.closest('[data-section-type="product-template"]');
        const priceSource = productRoot ? productRoot.querySelector('.js-product-price') : null;

        const sync = () => {
          const available = Boolean(addToCart && !addToCart.disabled);

          action.dataset.available = available ? 'true' : 'false';
          action.textContent = available ? action.dataset.selectLabel : action.dataset.notifyLabel;

          if (price && priceSource) {
            const nextPrice = priceSource.textContent.trim();
            if (nextPrice) price.textContent = nextPrice;
          }
        };

        action.addEventListener('click', () => {
          if (action.dataset.available === 'true') {
            form.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }

          const notify = document.querySelector(`#product-back-in-stock-${sectionId} .open-back_in_stock`);

          if (notify) {
            const dialogId = notify.getAttribute('aria-controls');
            const dialog = dialogId ? document.getElementById(dialogId) : null;

            if (dialog) {
              dialog.classList.add('active');

              const content = dialog.querySelector('.content-form');
              if (content) content.style.display = 'block';

              const firstField = dialog.querySelector('input:not([type="hidden"]), button, textarea, select');
              if (firstField) firstField.focus();
            } else {
              notify.click();
            }
          } else {
            form.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        });

        const observer = new MutationObserver(sync);
        observer.observe(form, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });

        if (priceSource) {
          observer.observe(priceSource, {
            childList: true,
            characterData: true,
            subtree: true
          });
        }

        sync();
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initMobilePurchaseBars, { once: true });
    } else {
      initMobilePurchaseBars();
    }

    document.addEventListener('shopify:section:load', initMobilePurchaseBars);
  })();
  } catch(e) { console.error(e); }
})();

})();
